(function () {
  const setImagePosition = (section) => {
    if (!section || !section?.classList.contains("hero-section")) return;

    const imageWrapper = section.querySelector(".hero-sticky-image-container");
    const heading = section.querySelector(".hero-heading");

    if (!imageWrapper || !heading) return;

    const setPosition = () => {
      const headingRect = heading.getBoundingClientRect();
      const imageRect = imageWrapper.getBoundingClientRect();

      const imageWrapperTop =
        heading.offsetTop + (5 * (headingRect.height / 2)) - imageRect.height / 2;

      imageWrapper.style.top = `${imageWrapperTop}px`;
      imageWrapper.style.transform = "translateX(-50%)";
    };

    setPosition();
    imageWrapper.classList.add("show");

    window.addEventListener("resize", setPosition);
  };

  const initHero = (section) => {
    if (!section || !section?.classList.contains("hero-section")) return;

    const container = section.querySelector(".hero.animate");

    if (!container) return;

    if (container.classList.contains("hero--first-section")) {
      container.classList.add("animated");
      return;
    }

    ScrollTrigger.create({
      trigger: container,
      start: "50% bottom",
      end: "bottom top",
      onEnter: () => container.classList.add("animated"),
    });
  };

  const initAnimation = (section) => {
    if (
      !section ||
      !section?.classList.contains("hero-section") ||
      !section.querySelector(".hero-sticky-image")
    )
      return;

    const heroSection = section.querySelector(".hero.animate");

    if (!heroSection) return;

    const imageWrapper = section.querySelector(".hero-sticky-image-container");

    if (!imageWrapper) return;

    const heading = section.querySelector(".hero-heading");

    let imageWrapperTop = 0;

    if (heading) {
      const headingRect = heading.getBoundingClientRect();
      const imageRect = imageWrapper.getBoundingClientRect();
      imageWrapperTop =
        heading.offsetTop + (2.3 * (headingRect.height / 2)) - imageRect.height / 2;
    }

    const calculateProgress = () => {
      const sectionRect = heroSection.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Start when the section enters the viewport
      const start = window.scrollY + sectionRect.top;
      // const start = (windowHeight / 4.5);

      // End when the section height (160vh) is fully scrolled
      const end = start + sectionRect.height - windowHeight;

      // Calculate progress (clamp between 0 and 1)
      const scrollPosition = window.scrollY;
      let progress = (scrollPosition - start) / (end - start);
      progress = Math.min(Math.max(progress, 0), 1);   
      // Update the CSS variable
      
      heroSection.style.setProperty("--progress", progress);

      if(section.querySelector('.hero-secondary-heading-wrapper') != null) {
        section.querySelector('.hero-secondary-heading-wrapper').style.setProperty("--progress", progress*1.1);
      }

      // Update the image position
      if (heading) {
        const imageWrapperTopPos = imageWrapperTop * (1 - progress);
        imageWrapper.style.top = `${imageWrapperTopPos}px`;
        //console.log(imageWrapper.getBoundingClientRect().height);
        const scrollYTrigger = window.innerHeight * 0.3;
        if(imageWrapper.getBoundingClientRect().height != imageWrapper.getBoundingClientRect().width && scrollY > scrollYTrigger) {
          // imageWrapper.style.borderBottomLeftRadius = "0";
          // imageWrapper.style.borderBottomRightRadius = "0";
          imageWrapper.style.width = "100%";
          // imageWrapper.style.top = `${imageWrapperTopPos + 80}px`;
          imageWrapper.style.top = `unset`;
          imageWrapper.style.bottom = `0`;
          
          if (window.scrollY > 700) {
            imageWrapper.style.clipPath = `ellipse(75% 100% at 50% 100%)`;
          } else {
            if (window.innerWidth < 992) {
              imageWrapper.style.clipPath = `ellipse(105% 100% at 50% 100%)`; 
            }
            else
            {
              imageWrapper.style.clipPath = `ellipse(58% 100% at 50% 100%)`;   
            }
          }
        } else {
          // imageWrapper.style.borderBottomLeftRadius = "var(--image-cont-border-radius)";
          // imageWrapper.style.borderBottomRightRadius = "var(--image-cont-border-radius)";
          imageWrapper.style.width = "clamp(var(--image-initial-size),var(--image-initial-size) + (var(--progress) - 0) / 1 * (100vw - var(--image-initial-size)),100vw)";
          console.log(progress, (1 + progress));
          imageWrapper.style.clipPath = `circle(${50 * (1 - progress) }%)`;
          imageWrapper.style.bottom = `unset`;
          imageWrapper.style.top = `60%`;

        }
      }
    };

    // Attach event listeners for scroll and resize
    window.addEventListener("scroll", calculateProgress);
    window.addEventListener("resize", calculateProgress);

    // Initialize progress on page load
    calculateProgress();
  };

  setImagePosition(document.currentScript.parentElement);
  initHero(document.currentScript.parentElement);
  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (e) {
    setImagePosition(e.target);
    initHero(e.target);
    initAnimation(e.target);
  });
})();
